import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { useSetNewPassword } from '@/features/auth/hooks/useSetNewPassword';

export const ResetPasswordPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const token = new URLSearchParams(location.search).get('token') || '';

    const { setNewPassword, loading, error } = useSetNewPassword();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [touched, setTouched] = useState(false);
    const [localError, setLocalError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setTouched(true);

        if (!password || !confirm) {
            setLocalError('Заполните оба поля');
            return;
        }

        if (password !== confirm) {
            setLocalError('Введённые вами пароли не совпадают!');
            return;
        }

        setLocalError(null);

        const ok = await setNewPassword({ token, password });
        if (ok) {
            navigate('/password-updated');
        } else {
            setLocalError('Не удалось изменить пароль. Попробуйте позже.');
        }
    };

    const passwordTooShort = password.length > 0 && password.length < 6;
    const mismatch = password !== confirm;

    return (
        <main className="layout__content">
            <section className="section layout__section auth">
                <div className="container">
                    <div className="auth__block auth-block">
                        <header className="auth-block__header" style={{ textAlign: 'center' }}>
                            <h1 className="title auth-block__title">Восстановление пароля</h1>
                            <p className="auth-form__hint-text" style={{ marginTop: 8 }}>
                                Для завершения восстановления пароля, пожалуйста, введите новый пароль:
                            </p>
                        </header>

                        <form className="form auth__form auth-form" onSubmit={handleSubmit} noValidate>
                            {(localError || error) && (
                                <div style={{ color: '#EA3323', marginBottom: '1rem', fontWeight: 500 }}>
                                    {localError || 'Ошибка сервера, попробуйте позже.'}
                                </div>
                            )}

                            <fieldset className="auth-form__fields">
                                <div className="form__row">
                                    <div className="input">
                                        <label htmlFor="password" className="input__label input-label">Новый пароль</label>
                                        <label className={clsx("text-input", {
                                            'text-input--error': touched && (passwordTooShort || !password)
                                        })}>
                                            <input
                                                id="password"
                                                className="text-input__input"
                                                type={show1 ? 'text' : 'password'}
                                                placeholder="Введите новый пароль"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                            <div className="text-input__control">
                                                <button
                                                    type="button"
                                                    onClick={() => setShow1(p => !p)}
                                                    className="text-input__icon text-input__password-toggle"
                                                >
                                                    <svg className="svg-icon">
                                                        <use
                                                            href={`${show1 ? '/img/sprite-icons.svg#eye-slash-fill' : '/img/sprite-icons.svg#eye-fill'}`} />
                                                    </svg>
                                                </button>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                                <div className="form__row">
                                    <div className="input">
                                        <label htmlFor="confirm" className="input__label input-label">Повторите пароль</label>
                                        <label className={clsx("text-input", {
                                            'text-input--error': touched && (mismatch || !confirm)
                                        })}>
                                            <input
                                                id="confirm"
                                                className="text-input__input"
                                                type={show2 ? 'text' : 'password'}
                                                placeholder="Повторите пароль"
                                                value={confirm}
                                                onChange={(e) => setConfirm(e.target.value)}
                                                required
                                            />
                                            <div className="text-input__control">
                                                <button
                                                    type="button"
                                                    onClick={() => setShow2(p => !p)}
                                                    className="text-input__icon text-input__password-toggle"
                                                >
                                                    <svg className="svg-icon">
                                                        <use
                                                            href={`${show2 ? '/img/sprite-icons.svg#eye-slash-fill' : '/img/sprite-icons.svg#eye-fill'}`} />
                                                    </svg>
                                                </button>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset className="auth-form__submit">
                                <button
                                    type="submit"
                                    className="button button_outline button_block auth-form__submit-button"
                                    disabled={loading}
                                >
                                    {loading ? 'Сохранение...' : 'Сохранить новый пароль'}
                                </button>
                                <p className="auth-form__hint-text" style={{ marginTop: 12 }}>
                                    После изменения пароля вы сможете войти в систему, используя новые данные.
                                </p>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    );
};
